
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsExchangeRateGrid extends Serenity.EntityGrid<PsExchangeRateRow, any> {
        protected getColumnsKey() { return PsExchangeRateColumns.columnsKey; }
        protected getDialogType() { return PsExchangeRateDialog; }
        protected getIdProperty() { return PsExchangeRateRow.idProperty; }
        protected getInsertPermission() { return PsExchangeRateRow.insertPermission; }
        protected getLocalTextPrefix() { return PsExchangeRateRow.localTextPrefix; }
        protected getService() { return PsExchangeRateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this
            });

            return this.slickGrid;
        }
    }
}